import ListPageLayout from "../../components/layout/ListPageLayout";
import filesApi from "../../services/filesApi";
import foldersApi from "../../services/foldersApi";
import {useParams} from "react-router";
import { useState, useEffect } from "react";

export default function Files() {
    const { folderId } = useParams();
    const [folderName, setFolderName] = useState("...");

    useEffect(() => {
        async function fetchFolderName() {
            try {
                const response = await foldersApi.one(String(folderId));
                setFolderName(response.data.name);
            } catch (error) {
                console.error("Erro ao buscar o nome da pasta:", error);
                setFolderName("Pasta não encontrada");
            }
        }
        
        if (folderId) {
            fetchFolderName();
        }
    }, [folderId]);
    
    return (
        <ListPageLayout
            title={`Cadastro de Arquivos - ${folderName}`}
            urlReturn={'/pastas'}
            urlCreate={`/pastas/${folderId}/arquivos/formulario`}
            queries={{
                ['relations']: 'type,userCreate,properties',
                ['where']: `id_folder,=,${folderId}`
            }}
            collunSearch={'description'}
            permission={'files.edit'}
            table={
                {
                    loader: filesApi.all,
                    columns: [
                        { label: "Descrição", index: "description", type: 'string'},
                        { label: "Tipo do Documento", index: "type.description", type: 'string'},
                        { label: "Imóveis", index: "properties", type: 'array'},
                        { label: "Usuário", index: "user_create.name", type: 'string'},
                        { label: "Data", index: "created_at", type: 'dateT'},
                    ]
                }
            }
        />
    )
}